import type {
  GetOrganizationFromStorageProps,
  OrganizationTreeCardState,
  SaveOrganizationInStorageProps,
} from "./organization-tree-card.type";

import { getLocalStorageIntValue } from "@/utilities/local-storage";

export const getOrganizationFromStorage = ({
  saveStateKey,
}: GetOrganizationFromStorageProps): OrganizationTreeCardState => {
  if (!saveStateKey) return undefined;

  const id = getLocalStorageIntValue(`${saveStateKey}-id`);
  const name = localStorage.getItem(`${saveStateKey}-name`);

  if (!id || !name) return undefined;

  return { id, name };
};

export const saveOrganizationInStorage = ({
  saveStateKey,
  organization,
}: SaveOrganizationInStorageProps) => {
  if (!saveStateKey) return;

  const id = organization?.id ?? "";
  localStorage.setItem(`${saveStateKey}-id`, `${id}`);

  const name = organization?.name ?? "";
  localStorage.setItem(`${saveStateKey}-name`, name);
};
